// eslint-disable-next-line no-shadow
export const enum SignUpStatus {
  CreateAccount = 0,
  VerifyNotification = 1,
}

export const INDUSTRY_OPTIONS = [
  { id: "Agriculture and Farming", name: "Agriculture and Farming" },
  { id: "Automotive", name: "Automotive" },
  { id: "Aviation and Aerospace", name: "Aviation and Aerospace" },
  { id: "Banking and Finance", name: "Banking and Finance" },
  { id: "Biotechnology", name: "Biotechnology" },
  { id: "Chemical", name: "Chemical" },
  { id: "Construction", name: "Construction" },
  { id: "Consulting", name: "Consulting" },
  { id: "Consumer Goods and Services", name: "Consumer Goods and Services" },
  { id: "Education and Training", name: "Education and Training" },
  { id: "Energy and Utilities", name: "Energy and Utilities" },
  { id: "Entertainment and Media", name: "Entertainment and Media" },
  { id: "Food and Beverage", name: "Food and Beverage" },
  { id: "Government and Public Sector", name: "Government and Public Sector" },
  { id: "Healthcare and Pharmaceuticals", name: "Healthcare and Pharmaceuticals" },
  { id: "Hospitality and Tourism", name: "Hospitality and Tourism" },
  { id: "Information Technology (IT)", name: "Information Technology (IT)" },
  { id: "Insurance", name: "Insurance" },
  { id: "Internet and E-commerce", name: "Internet and E-commerce" },
  { id: "Manufacturing", name: "Manufacturing" },
  { id: "Mining and Metals", name: "Mining and Metals" },
  { id: "Non-profit and Social Services", name: "Non-profit and Social Services" },
  { id: "Real Estate and Property", name: "Real Estate and Property" },
  { id: "Retail", name: "Retail" },
  { id: "Telecommunications", name: "Telecommunications" },
  { id: "Transportation and Logistics", name: "Transportation and Logistics" },
  { id: "Wholesale and Distribution", name: "Wholesale and Distribution" },
];
